import {BaseParameterFilterInputProps} from "./BaseParameterFilterInputProps";
import {ParameterDataType} from "../../types/Category";

export interface ParameterFilterInputPropsString
    extends BaseParameterFilterInputProps {
    dataType: ParameterDataType.STRING;
    value: string;
}

const StringParameterInput: React.FC<ParameterFilterInputPropsString> =
    ({ name,
       value,
       onChange,
     }) =>
{
    return (
        <input
            type="text"
            value={value}
            placeholder="Enter value"
            onChange={(e) => onChange(name, e.target.value)}
            style={{ width: 200 }}
        />
    );
};

export default StringParameterInput;